import config from '../config';

function getAuthToken(): string | null {
  // Retrieve authentication token from localStorage, same token is used for API requests
  return localStorage.getItem('authToken');
}

export async function getRequest<T>(
  endpoint: string,
  authRequired = true,
): Promise<T> {
  const headers: HeadersInit = { 'Content-Type': 'application/json' };

  // Add the Authorization header if authRequired is true and token exists
  if (authRequired) {
    const token = getAuthToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }
  // remove the leading slash from the endpoint
  const newEndpoint = endpoint.startsWith('/')
    ? endpoint.substring(1)
    : endpoint;

  const url = new URL(newEndpoint, config.apiBaseUrl + '/');
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    let errorMessage = `API error: ${response.statusText}`;
    try {
      const errorData = await response.json();
      if (errorData.error) {
        errorMessage = errorData.error;
      }
    } catch {
      // Ignore JSON parsing errors and keep the default message
    }
    throw new Error(errorMessage);
  }

  return response.json();
}

export async function postRequest(
  endpoint: string,
  body?: object,
  authRequired = true,
) {
  const headers: HeadersInit = { 'Content-Type': 'application/json' };

  // Add the Authorization header if authRequired is true and token exists
  if (authRequired) {
    const token = getAuthToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }
  // remove the leading slash from the endpoint
  const newEndpoint = endpoint.startsWith('/')
    ? endpoint.substring(1)
    : endpoint;

  const url = new URL(newEndpoint, config.apiBaseUrl + '/');
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  console.log('response ::: ', response);
  console.log(url);

  if (!response.ok) {
    let errorMessage = `API error: ${response.statusText}`;
    try {
      const errorData = await response.json();
      if (errorData.error) {
        errorMessage = errorData.error;
      }
    } catch {
      // Ignore JSON parsing errors and keep the default message
    }
    throw new Error(errorMessage);
  }

  return response.json();
}

export async function putRequest(
  endpoint: string,
  body?: object,
  authRequired = true,
) {
  const headers: HeadersInit = { 'Content-Type': 'application/json' };

  // Add the Authorization header if authRequired is true and token exists
  if (authRequired) {
    const token = getAuthToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }
  // remove the leading slash from the endpoint
  const newEndpoint = endpoint.startsWith('/')
    ? endpoint.substring(1)
    : endpoint;

  const url = new URL(newEndpoint, config.apiBaseUrl + '/');
  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  console.log('response ::: ', response);
  console.log(url);

  if (!response.ok) {
    let errorMessage = `API error: ${response.statusText}`;
    try {
      const errorData = await response.json();
      if (errorData.error) {
        errorMessage = errorData.error;
      }
    } catch {
      // Ignore JSON parsing errors and keep the default message
    }
    throw new Error(errorMessage);
  }

  return response.json();
}

export async function deleteRequest(endpoint: string, authRequired = true) {
  const headers: HeadersInit = { 'Content-Type': 'application/json' };

  // Add the Authorization header if authRequired is true and token exists
  if (authRequired) {
    const token = getAuthToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }
  // remove the leading slash from the endpoint
  const newEndpoint = endpoint.startsWith('/')
    ? endpoint.substring(1)
    : endpoint;

  const url = new URL(newEndpoint, config.apiBaseUrl + '/');
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
  });

  if (!response.ok) {
    let errorMessage = `API error: ${response.statusText}`;
    try {
      const errorData = await response.json();
      if (errorData.error) {
        errorMessage = errorData.error;
      }
    } catch {
      // Ignore JSON parsing errors and keep the default message
    }
    throw new Error(errorMessage);
  }
}
